import { z } from "zod";

import { imagesSchema } from "../imagesSchema";

export const basePrayerSchema = z.object({
  collection_id: z.number(),
  detailed_desc: z.string(),
  has_access: z.boolean(),
  has_video: z.boolean().optional().nullable(),
  id: z.number(),
  images: imagesSchema,
  is_available: z.boolean(),
  is_completed: z.boolean(),
  is_download_enabled: z.boolean(),
  is_favorite: z.boolean(),
  is_redeemed: z.boolean(),
  is_sensitive: z.boolean(),
  is_song: z.boolean(),
  label_desc: z.string(),
  lengths: z.string().nullable(),
  order: z.number().nullable(),
  prompt: z.string().nullable(),
  shareable_quote: z.string().nullable(),
  shareable_url: z.string(),
  supertitle: z.string(),
  title: z.string(),
});

export type BasePrayer = z.infer<typeof basePrayerSchema>;
